declare namespace $ {

	export class $shm_hitalama_text_link extends $mol_link_iconed {
		favicon( ): boolean
	}
	
}

//# sourceMappingURL=link.view.tree.d.ts.map